// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PReloadOutlinedSvg from "@fishx/icons-svg/es/asn/PReloadOutlined";
import FishxIcon from '../components/FishxIcon';

var PReloadOutlined = function PReloadOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PReloadOutlinedSvg
  }));
};

PReloadOutlined.displayName = 'PReloadOutlined';
export default React.forwardRef(PReloadOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PReloadOutlined.js
// module id = 3585
// module chunks = 0